// template 소스 나중에 걷어낼것.
import { all } from 'redux-saga/effects';

export default function* themeSaga() {
  yield all([]);
}
